import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, Collapse } from '@woovi/ui';

import type { PaymentCompanySupport_company$key } from './__generated__/PaymentCompanySupport_company.graphql.ts';
import PaymentCompanySupportEmail from './PaymentCompanySupportEmail.tsx';
import PaymentCompanySupportPhone from './PaymentCompanySupportPhone.tsx';
import PaymentCompanySupportWebsite from './PaymentCompanySupportWebsite.tsx';
import PaymentCompanySupportWhatsApp from './PaymentCompanySupportWhatsApp.tsx';

import type { ReactNode } from 'react';

type PaymentCompanySupportProps = {
  company: PaymentCompanySupport_company$key;
};

const PaymentCompanySupport = (
  props: PaymentCompanySupportProps,
): ReactNode => {
  const theme = useTheme();
  const { t } = useTranslation();

  const company = useFragment<PaymentCompanySupport_company$key>(
    graphql`
      fragment PaymentCompanySupport_company on Company {
        preferences {
          support {
            email
            phone
            website
          }
        }
        ...PaymentCompanySupportEmail_company
        ...PaymentCompanySupportPhone_company
        ...PaymentCompanySupportWebsite_company
        ...PaymentCompanySupportWhatsApp_company
      }
    `,
    props.company,
  );

  if (
    !company.preferences?.support?.email &&
    !company.preferences?.support?.phone &&
    !company.preferences?.support?.website
  ) {
    return;
  }

  return (
    <BoxFlex
      sx={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        paddingX: theme.spacing(1),
      }}
    >
      <Collapse
        header={
          <Typography sx={{ fontWeight: theme.typography.fontWeightBold }}>
            {t('Contact the seller')}
          </Typography>
        }
      >
        <Stack spacing={2}>
          <PaymentCompanySupportEmail company={company} />
          <PaymentCompanySupportWebsite company={company} />
          <PaymentCompanySupportPhone company={company} />
          <PaymentCompanySupportWhatsApp company={company} />
        </Stack>
      </Collapse>
    </BoxFlex>
  );
};

export default PaymentCompanySupport;
